const drawerInitialState = {
    drawerOpened: false,
};

export default drawerInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/Drawer/drawerInitialState.js